<template>
    <dash
        icon="fa fa-exclamation-triangle"
        titulo="ENTREGAS SEM COMPROMETIMENTO"
        :qtd="qtd"
        :loading="loading"
        color="#ffa600"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent2'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
